module.exports = __webpack_public_path__ + "img/14_10.ba2deb30.png";